import { render, staticRenderFns } from "./c_page_ueditor.vue?vue&type=template&id=08426de7&scoped=true"
import script from "./c_page_ueditor.vue?vue&type=script&lang=js"
export * from "./c_page_ueditor.vue?vue&type=script&lang=js"
import style0 from "./c_page_ueditor.vue?vue&type=style&index=0&id=08426de7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08426de7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08426de7')) {
      api.createRecord('08426de7', component.options)
    } else {
      api.reload('08426de7', component.options)
    }
    module.hot.accept("./c_page_ueditor.vue?vue&type=template&id=08426de7&scoped=true", function () {
      api.rerender('08426de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_page_ueditor.vue"
export default component.exports